
import { Component } from 'react';
import { Card, Table, Button, Row, Col, Modal, Form, Badge, Spinner, Alert } from 'react-bootstrap';
import { FaSearch, FaEraser, FaRegPaperPlane } from 'react-icons/fa';
import Paginacao from '../../common/pagination';
import faqRecebidasService from '../../api/faq/faqRecebidasService';
import programaFaqService from '../../api/faq/programaFaqService';
import faqAreasService from '../../api/faq/faqAreasService';
import { getCurrentUser } from '../../common/utils';
import { isSuperUser } from '../../common/userUtils';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import AsyncSelect from 'react-select/async';
import api from "../../services/api";

class FaqRecebidas extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            error: '',
            
            // Filters
            busca: '',
            programaSelecionado: null,
            areaSelecionada: '',

            // Data
            listRecebidas: [],
            areas: [],
            
            // Pagination
            page_numb: 1,
            total: 0,
            next: null,
            previous: null,

            // Modal Responder
            showModal: false,
            respondingItem: null,
            pergunta: '',
            resposta: '',
            area_id: '',
            submitLoading: false,
            respostaError: '',
        };
    }

    componentDidMount() {
        this.carregarAreas();
        this.carregarDados();
    }

    carregarAreas = () => {
         faqAreasService.getAll({ ativo: true })
            .then(res => {
                this.setState({ areas: res.data.results || [] });
            })
            .catch(err => console.error("Erro ao carregar áreas:", err));
    }

    carregarProgramas = async (inputValue = "") => {
        try {
            const response = await api.get(`/programas/?nome=${encodeURIComponent(inputValue)}`);
            return (response.data.results || []).map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
        } catch (error) {
            return [];
        }
    };

    carregarDados = (page = 1) => {
        const { busca, programaSelecionado, areaSelecionada } = this.state;
        const dados_usuario = getCurrentUser();
        
        let params = { page };

        if (isSuperUser(dados_usuario)) {
             if (programaSelecionado) {
                 params.programa_id = programaSelecionado.value;
             }
        } else {
             if (dados_usuario.ambiente_programa_id) {
                 params.programa_id = dados_usuario.ambiente_programa_id;
             }
        }

        if (busca) params.search = busca;
        if (areaSelecionada) params.area_id = areaSelecionada;

        this.setState({ loading: true, error: '' });

        faqRecebidasService.getAll(params)
            .then(response => {
                const results = response.data.results || [];
                const total = response.data.count || results.length;
                this.setState({
                    listRecebidas: results,
                    total: total,
                    next: response.data.next,
                    previous: response.data.previous,
                    page_numb: page,
                    loading: false
                });
            })
            .catch(error => {
                let msg = 'Erro ao carregar dúvidas recebidas';
                if (error.response && error.response.status === 403) msg = 'Permissão negada';
                this.setState({ loading: false, error: msg });
            });
    }

    onChangeBusca = (e) => this.setState({ busca: e.target.value });
    
    onChangePrograma = (opt) => this.setState({ programaSelecionado: opt });

    onChangeAreaFilter = (e) => this.setState({ areaSelecionada: e.target.value });

    onBuscar = (e) => {
        e.preventDefault();
        this.carregarDados(1);
    }
    
    onLimpar = () => {
        this.setState({
            busca: '',
            programaSelecionado: null,
            areaSelecionada: ''
        }, () => this.carregarDados(1));
    }

    onClickPagina = (p) => this.carregarDados(p);

    // Modal Actions
    abrirModalResponder = (item) => {
        this.setState({
            showModal: true,
            respondingItem: item,
            pergunta: item.pergunta, // Pre-fill
            resposta: '',
            area_id: item.area || '', // Pre-fill if exists
            submitLoading: false,
            respostaError: ''
        });
    }

    fecharModal = () => this.setState({ showModal: false, respondingItem: null });

    onChangeModalField = (e) => this.setState({ [e.target.name]: e.target.value });
    
    handleRespostaChange = (value) => this.setState({ resposta: value });

    handleSubmit = async () => {
        const { respondingItem, pergunta, resposta, area_id } = this.state;

        if (!resposta || resposta.trim() === '' || resposta === '<p><br></p>') {
            this.setState({ respostaError: 'A resposta é obrigatória.' });
            return;
        }

        this.setState({ submitLoading: true });
        const MySwal = withReactContent(Swal);

        try {
            const faqData = {
                programa_id: respondingItem.programa,
                pergunta: pergunta,
                resposta: resposta,
                area_id: area_id || null
            };
            await programaFaqService.create(faqData);

            await faqRecebidasService.update(respondingItem.id, { respondido: true });

            MySwal.fire({
                title: 'Sucesso',
                text: 'Dúvida respondida e cadastrada na FAQ!',
                icon: 'success'
            });

            this.fecharModal();
            this.carregarDados(this.state.page_numb);

        } catch (error) {
             console.error(error);
             MySwal.fire({
                title: 'Erro',
                text: 'Falha ao salvar resposta. Tente novamente.',
                icon: 'error'
            });
        } finally {
            this.setState({ submitLoading: false });
        }
    }

    render() {
        const { 
            loading, error, listRecebidas, total, page_numb, next, previous,
            busca, programaSelecionado, areaSelecionada, areas,
            showModal, pergunta, resposta, area_id, submitLoading, respostaError
        } = this.state;
        
        const dados_usuario = getCurrentUser();
        const superUser = isSuperUser(dados_usuario);

        return (
            <div>
                 <Card className="cardDestaque mb-3">
                    <Card.Body>
                        <Row className="mb-3">
                            <Col xs={12}><h4>Filtros</h4></Col>
                        </Row>
                        <Form onSubmit={this.onBuscar}>
                            <Row>
                                {superUser && (
                                    <Col sm={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Programa</Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={this.carregarProgramas}
                                                value={programaSelecionado}
                                                onChange={this.onChangePrograma}
                                                placeholder="Todos os Programas"
                                            />
                                        </Form.Group>
                                    </Col>
                                )}
                                <Col sm={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Área</Form.Label>
                                        <Form.Control as="select" value={areaSelecionada} onChange={this.onChangeAreaFilter}>
                                            <option value="">Todas</option>
                                            {areas.map(a => <option key={a.id} value={a.id}>{a.nome}</option>)}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col sm={superUser ? 6 : 9}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Buscar</Form.Label>
                                        <Form.Control 
                                            placeholder="Buscar em pergunta ou contexto..." 
                                            value={busca} 
                                            onChange={this.onChangeBusca} 
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className="d-flex gap-2">
                                <Button type="submit" variant="primary" size="sm"><FaSearch className="me-1"/> Buscar</Button>
                                <Button type="button" variant="light" size="sm" onClick={this.onLimpar}><FaEraser className="me-1"/> Limpar</Button>
                            </div>
                        </Form>
                    </Card.Body>
                 </Card>

                 <Card className="hns-form-card">
                    <Card.Body>
                        {loading ? (
                            <div className="text-center p-3"><Spinner animation="border"/></div>
                        ) : error ? (
                            <Alert variant="danger">{error}</Alert>
                        ) : (
                            <>
                                <Table responsive className="custom-table mt-3">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Pergunta</th>
                                            <th>Usuário</th>
                                            <th>Programa</th>
                                            <th>Área</th>
                                            <th>Contexto</th>
                                            <th>Respondido?</th>
                                            {superUser && <th className="text-end">Ações</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listRecebidas.length === 0 ? (
                                            <tr><td colSpan={8} className="text-center">Nenhuma dúvida encontrada.</td></tr>
                                        ) : listRecebidas.map(item => (
                                            <tr key={item.id}>
                                                <td>{item.id}</td>
                                                <td>
                                                    <span title={item.pergunta}>{item.pergunta.length > 50 ? item.pergunta.substring(0,50)+'...' : item.pergunta}</span>
                                                </td>
                                                <td>
                                                    {item.dados_usuario ? (
                                                        <div>
                                                            <div>{item.dados_usuario.nome}</div>
                                                            <small className="text-muted">{item.dados_usuario.email}</small>
                                                        </div>
                                                    ) : item.usuario}
                                                </td>
                                                <td>{item.dados_programa ? item.dados_programa.nome : item.programa}</td>
                                                <td>{item.dados_area ? item.dados_area.nome : item.area}</td>
                                                <td><small>{item.contexto}</small></td>
                                                <td>
                                                    {item.respondido ? 
                                                        <Badge bg="success">Sim</Badge> : 
                                                        <Badge bg="warning" text="dark">Não</Badge>
                                                    }
                                                </td>
                                                {superUser && (
                                                    <td className="text-end">
                                                        {!item.respondido && (
                                                            <Button 
                                                                variant="primary" 
                                                                size="sm" 
                                                                onClick={() => this.abrirModalResponder(item)}
                                                            >
                                                                Responder
                                                            </Button>
                                                        )}
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>

                                {total > 0 && (
                                     <Paginacao 
                                        dados={{ count: total, next, previous }} 
                                        page_numb={page_numb} 
                                        _onClickPagina={this.onClickPagina} 
                                     />
                                )}
                            </>
                        )}
                    </Card.Body>
                 </Card>

                 {/* Modal Responder */}
                 <Modal show={showModal} onHide={this.fecharModal} size="lg" backdrop="static">
                     <Modal.Header closeButton>
                         <Modal.Title>Responder Dúvida #{this.state.respondingItem?.id}</Modal.Title>
                     </Modal.Header>
                     <Modal.Body>
                         <Form>
                             <Form.Group className="mb-3">
                                 <Form.Label>Pergunta (Será cadastrada na FAQ)</Form.Label>
                                 <Form.Control 
                                     value={pergunta} 
                                     onChange={(e) => this.setState({ pergunta: e.target.value })} 
                                 />
                             </Form.Group>
                             <Form.Group className="mb-3">
                                 <Form.Label>Área</Form.Label>
                                 <Form.Control
                                    as="select" 
                                    value={area_id} 
                                    onChange={(e) => this.setState({ area_id: e.target.value })}
                                 >
                                     <option value="">Selecione...</option>
                                     {areas.map(a => <option key={a.id} value={a.id}>{a.nome}</option>)}
                                 </Form.Control>
                             </Form.Group>
                             <Form.Group className="mb-3">
                                 <Form.Label>Resposta</Form.Label>
                                 {respostaError && <Alert variant="danger">{respostaError}</Alert>}
                                 <ReactQuill 
                                    theme="snow" 
                                    value={resposta} 
                                    onChange={this.handleRespostaChange} 
                                 />
                             </Form.Group>
                         </Form>
                     </Modal.Body>
                     <Modal.Footer>
                        <Button size="sm" variant="light" onClick={this.fecharModal}>Cancelar</Button>
                        <Button size="sm" variant="success" onClick={this.handleSubmit} disabled={submitLoading}>
                            {submitLoading ? <Spinner size="sm" animation="border"/> : <><FaRegPaperPlane className="me-1"/> Enviar e Salvar</>}
                        </Button>
                     </Modal.Footer>
                 </Modal>
            </div>
        );
    }
}

export default FaqRecebidas;
